import { FC } from 'react'
import { InfoPageWrapper } from './info-page-wrapper'

const WhoWeAre: FC = () => <InfoPageWrapper id="who-we-are" />

export default WhoWeAre
